export default __webpack_public_path__ + "static/media/lace_type.d0226db0.jpeg";